import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50 rounded-2xl mx-4 md:mx-6 mb-6 overflow-hidden">
      <div className="px-6 md:px-10 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
          {/* Subscribe */}
          <div className="md:col-span-5">
            <h3 className="font-heading text-3xl md:text-4xl text-background-50 mb-3">订阅瓜报</h3>
            <p className="text-foreground-300 text-sm mb-5 leading-relaxed">
              第一时间获取最新爆料和热门大瓜，不错过任何一个精彩瞬间。
            </p>
            <form
              className="flex flex-col sm:flex-row gap-3"
              data-readdy-form="true"
              onSubmit={(e) => e.preventDefault()}
            >
              <input
                type="email"
                name="email"
                placeholder="输入您的邮箱"
                className="flex-1 bg-transparent border-b border-foreground-600 px-2 py-3 text-sm text-background-50 placeholder:text-foreground-500 outline-none focus:border-accent-400 transition-colors"
                required
              />
              <button
                type="submit"
                className="px-6 py-3 rounded-full bg-background-50 text-foreground-900 text-sm font-medium hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                订阅 <i className="ri-arrow-right-line ml-1.5"></i>
              </button>
            </form>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-3">
            <h4 className="text-sm font-medium text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-sm text-foreground-300 hover:text-background-50 transition-colors border-b border-foreground-700 pb-1 cursor-pointer">首页</Link>
              <Link to="/about" className="text-sm text-foreground-300 hover:text-background-50 transition-colors border-b border-foreground-700 pb-1 cursor-pointer">关于我们</Link>
              {categories.slice(0, 3).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-300 hover:text-background-50 transition-colors border-b border-foreground-700 pb-1 cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <h4 className="text-sm font-medium text-background-50 mb-4">联系我们</h4>
            <div className="flex flex-col gap-3 text-sm text-foreground-300">
              <p className="border-b border-foreground-700 pb-1">
                <i className="ri-phone-line mr-2"></i>400-888-6666
              </p>
              <p className="border-b border-foreground-700 pb-1">
                <i className="ri-mail-line mr-2"></i>tips@jinrichigua.com
              </p>
              <div className="mt-3">
                <p>北京市朝阳区望京SOHO T1</p>
                <p className="mt-1">B座 18层 1808室</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 border-t border-foreground-700 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-foreground-400">
          <div className="flex items-center gap-4">
            <a href="#" className="hover:text-background-50 transition-colors border-b border-foreground-600 cursor-pointer">微博</a>
            <a href="#" className="hover:text-background-50 transition-colors border-b border-foreground-600 cursor-pointer">微信公众号</a>
            <a href="#" className="hover:text-background-50 transition-colors border-b border-foreground-600 cursor-pointer">抖音</a>
          </div>
          <p>© 2026 今日吃瓜 All Rights Reserved</p>
          <div className="flex items-center gap-4">
            <a href="#" className="hover:text-background-50 transition-colors border-b border-foreground-600 cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-background-50 transition-colors border-b border-foreground-600 cursor-pointer">用户协议</a>
          </div>
        </div>
      </div>
    </footer>
  );
}